import { render, staticRenderFns } from "./oragnization-detail.vue?vue&type=template&id=6a0d067c&scoped=true"
import script from "./oragnization-detail.vue?vue&type=script&lang=js"
export * from "./oragnization-detail.vue?vue&type=script&lang=js"
import style0 from "./oragnization-detail.vue?vue&type=style&index=0&id=6a0d067c&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0d067c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a0d067c')) {
      api.createRecord('6a0d067c', component.options)
    } else {
      api.reload('6a0d067c', component.options)
    }
    module.hot.accept("./oragnization-detail.vue?vue&type=template&id=6a0d067c&scoped=true", function () {
      api.rerender('6a0d067c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/organizations/components/oragnization-detail.vue"
export default component.exports